
<div>
  <org-header></org-header>

  <div
    class="row m-0 p-0 signup-content-wrap flex-xs-wrap-reverse flex-sm-wrap-reverse"
  >
    <div
      class="col-sm-12 col-md-12 col-lg-6 m-0 p-0 signup-content-one"
    ></div>
    <div class="col-sm-12 col-md-12 col-lg-6 m-0 p-0 signup-content-two">
      <h1 class="main-heading">
        You're moments away from experiencing Convrrt.
      </h1>

      <p class="supporting-txt">
        Every SaaS company is unique and has different needs. Complete the
        form and a product expert will be in touch.
      </p>

      <h3 class="sub-heading">
        Get started with your customized sandbox account
      </h3>

      <div class="signup-btns-wrap">
        <div class="google-btn-wrap">
          <a href="/api/oauth/google/login">
            <button class="signup-btns google-btn">
              <img
                class="social-logo-google"
                src="/static/img/organization/google-icon.svg"
                alt="Google Logo"
              />
              <span>Google</span>
            </button>
          </a>
        </div>

      </div>

      <p class="another-sup-txt-wrap">
        <span class="another-sup-span"
          >Don't have a Google business account?</span
        >
        <a class="another-sup-anchor" href="#"
          >Verify your work email another way</a
        >
      </p>

      <p class="acc-create-sup-txt-wrap">
        <span class="acc-create-sup-span"
          >By creating an account, you agree to our &nbsp;</span
        >
        <a class="acc-create-sup-anchor" href="#">Terms of Service &nbsp;</a>
        <span class="acc-create-sup-span">and &nbsp;</span>
        <a class="acc-create-sup-anchor" href="#">Privacy Policy.</a>
      </p>
    </div>
  </div>

  <div class="row m-0 p-0 saas-content-wrap">
    <div class="col-xs-12 saas-heading-wrap">
      <h3 class="saas-heading">
        SaaS leaders trust Convrrt to scale faster.
      </h3>
    </div>

    <div class="col-xs-12 saas-leader-imgs-wrap">
      <img
        src="/static/img/organization/client-logos/sendinblue-logo.png"
        alt="Sendinblue Logo"
      />
      <img
        src="/static/img/organization/client-logos/keap-logo.png"
        alt="Keap Logo"
      />
      <img
        src="/static/img/organization/client-logos/sharpspring-logo.png"
        alt="Sharpspring Logo"
      />
      <img
        src="/static/img/organization/client-logos/integrate-logo.png"
        alt="Integrate Logo"
      />
      <img
        src="/static/img/organization/client-logos/instamojo-logo.png"
        alt="Instamojo Logo"
      />
    </div>
  </div>

  <footer class="adm-footer-wrap">
    <div class="row adm-footer-inner-wrap">
      <div class="col-sm-4 col-md-2">
        <div class="footer-ul-wrap">
          <div class="footer-ul-heading">Solutions</div>

          <ul class="footer-ul">
            <li>
              <a href="#">Convrrt For SaaS</a>
            </li>
            <li>
              <a href="#">Convrrt For Product Managers</a>
            </li>
            <li>
              <a href="#">Convrrt For CTOs</a>
            </li>
            <li>
              <a href="#">The Platform</a>
            </li>
            <li>
              <a href="#">CRM Solution</a>
            </li>
            <li>
              <a href="#">SEO Page Builder</a>
            </li>
            <li>
              <a href="#">API Solutions</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm-4 col-md-2">
        <div class="footer-ul-wrap">
          <div class="footer-ul-heading">Resources</div>

          <ul class="footer-ul">
            <li>
              <a href="#">Guides</a>
            </li>
            <li>
              <a href="#">Webinars</a>
            </li>
            <li>
              <a href="#">Build Vs. Buy</a>
            </li>
            <li>
              <a href="#">ROI Calculator</a>
            </li>
            <li>
              <a href="#">Convrrt Vs. BeeFree</a>
            </li>
            <li>
              <a href="#">Convrrt Vs. Unlayer</a>
            </li>
            <li>
              <a href="#">Convrrt Vs. Simvoly</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm-4 col-md-2">
        <div class="footer-ul-wrap">
          <div class="footer-ul-heading">Case Studies</div>

          <ul class="footer-ul">
            <li>
              <a href="#">Keap</a>
            </li>
            <li>
              <a href="#">Sharpspring</a>
            </li>
            <li>
              <a href="#">SendInBlue</a>
            </li>
            <li>
              <a href="#">Freshworks</a>
            </li>
            <li>
              <a href="#">LionDesk</a>
            </li>
            <li>
              <a href="#">CRMGrow</a>
            </li>
            <li>
              <a href="#">Sellsy</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm-4 col-md-2">
        <div class="footer-ul-wrap">
          <div class="footer-ul-heading">Company</div>

          <ul class="footer-ul">
            <li>
              <a href="#">About Us</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">Pricing</a>
            </li>
            <li>
              <a href="#">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm-4 col-md-2">
        <div class="footer-ul-wrap">
          <div class="footer-icons-ul-heading">
            <a href="https://www.convrrt.com">
              <img
                class="adm-logo-2"
                src="/static/img/organization/convrrt-logo-2.svg"
                alt="Convrrt Logo"
              />
            </a>
          </div>

          <ul class="footer-icons-ul">
            <li>
              <a href="#">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="fab fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</div>
